<template>
    <ApprovedPayments></ApprovedPayments>
</template>
<script>
    import ApprovedPayments from '@/components/EmployeeApprovedPaymentLiquidations.vue'
    export default {
        name: 'approved-liquidations',
        components: {
            ApprovedPayments
        }
    }
</script>